var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"btn-loader",class:_vm.className,attrs:{"type":_vm.type,"variant":_vm.variant,"size":_vm.size,"disabled":_vm.disabled,"block":_vm.block},on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.loader)?_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"})]):_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }